var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('twemoji-textarea',{ref:"twemoji",staticStyle:{"width":"590px"},attrs:{"placeholder":_vm.$t('留下你的精彩评论吧'),"initialContent":_vm.input2,"emojiData":_vm.emojiDataAll,"emojiGroups":_vm.emojiGroups},on:{"contentChanged":_vm.contentChanged,"enterKey":_vm.onEnterKey,"click":_vm.tewojiClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307e26a7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/details/comment/twemoji.vue
// module id = null
// module chunks = 